/* Built In Imports */
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const BenefitsGroup = ({ sectionContent, region, lang, section }) => {
  // console.log('data-', sectionContent);
  let lomBenefits = section.sectionId === 'lom-benefits'
  return (
    <Box fontSize="18px" bgColor="#361B32" pt={{ base: '36px' }}>
      <SectionTitle
        titleObj={sectionContent[0]}
        color="#fff !important"
        maxW="360px"
        lang={lang}
      />
      <Box
        display="flex"
        justifyContent="center"
        w="full"
        maxW={lomBenefits ? {lg: '1000px'} : "1170px"}
        flexDir={{ base: 'column', md: 'row' }}
        mx="auto"
        alignContent="center"
      >
        {sectionContent[1]?.benefits?.map(data => {
          return (
            <Box
              key={``}
              mb={lomBenefits ? {base: '60px', md: '0px', lg: '0px'} : { base: '10px', md: '30px', lg: '53px' }}
              flexBasis={{ base: '90%', md: '30%' }}
            >
              <Flex alignItems="center" justifyContent="center">
                <LazyLoadImageComponent
                  loading="lazy"
                  src={data?.image?.url}
                  title={data?.image?.title}
                  height={lomBenefits ? '249px' : {
                    base: '279px',
                    md: '190px',
                    lg: '259px',
                  }}
                  minW={lomBenefits ? undefined : { md: '200px', lg: '274px' }}
                  objectFit={{ base: 'contain', md: 'cover' }}
                  m={{ base: '0 0 22px 0' }}
                  width={lomBenefits ? '258px' : undefined}
                />
              </Flex>
              <Text
                fontFamily={lomBenefits ? (lang=='en' ? 'FedraSansStd-book' : 'MuktaMalar') : "FedraSansStd-book, sans-serif"}
                fontSize={{
                  base: '16px',
                  md: lang == 'en' ? '16px' : '18px',
                }}
                width={{ base: '75%', md: '90%', lg: lomBenefits ? (lang == 'en'? '254px' : '265px') : '85%' }}
                color="#fff"
                mx="auto"
                textAlign="center"
                pt={{ base: '5px', sm: '10px', md: '0' }}
                fontWeight={lomBenefits && lang=='en' ? 600 : undefined}
              >
                {data?.text}
              </Text>
            </Box>
          );
        })}
      </Box>
      <Box
        w="full"
        px="20px"
        textAlign="center"
        pb="80px"
        // pb="40px"
        maxW="620px"
        m="0 auto"
      >
        {' '}
        {/* <StructuredTextParser
          str={render(sectionContent[2]?.body)}
          region={region}
          lang={language}
          fontSize="16px"
          textAlign="center"
          color="#fff"
          fontFamily="FedraSansStd-book"
          className="heading4"
        /> */}
      </Box>
      <style jsx global>
        {`
          .heading4 {
            padding: 0 15px;
          }
          .heading4 h4 {
            font-size: 24px;
            padding-bottom: 4px;
            color: #fbad2e;
            font-family: 'FedraSansStd-A-medium';
          }
          .heading4 p:nth-child(3) {
            padding-top: 8px;
            color: #ca9dc3;
            font-size: 14px;
            font-family: 'FedraSansStd-book-i';
            max-width: 400px;
            margin: 0 auto;
          }
        `}
      </style>
    </Box>
  );
};

export default BenefitsGroup;
